<template>
<div>
  <template v-if="yewuyuanInfo && yewuyuanInfo.id > 0">
    <template v-if="op=='add'">
      <van-nav-bar
        title="录入店铺"
        left-text="返回"
        left-arrow
        @click-left="op='main'"
      />
    <van-form class="form-box" label-width="1.2rem">
      <van-field name="checkboxGroup" required label="订购货品">
        <template #input>
          <van-checkbox-group v-model="form.product" direction="horizontal">
            <van-checkbox name="流量卡" shape="square">流量卡</van-checkbox>
            <van-checkbox name="设备" shape="square">设备</van-checkbox>
          </van-checkbox-group>
        </template>
      </van-field>
      <van-field v-model="form.price" required label="商品金额" type="number" >
        <template #right-icon>
          <span>元</span>
        </template>
      </van-field>
      <van-field v-model="form.name" required label="联系姓名" />
      <van-field v-model="form.mobile" required label="联系电话" type="digit" />
      <van-field
        readonly
        clickable
        name="area"
        required
        :value="showCity"
        label="收货地址"
        placeholder="点击选择省市区"
        @click="showArea = true"
      />
      <van-popup v-model="showArea" position="bottom">
        <van-area
          :area-list="areaList"
          @confirm="onConfirm"
          @cancel="showArea = false"
        />
      </van-popup>
      <van-field required v-model="form.address" label="详细地址" @click-right-icon="showMap=true" right-icon="location" />
      <van-field v-model="form.remark" label="业务备注" />
      <van-field required name="uploader" label="门头照片" class="showAsBlock">
        <template #input>
          <van-uploader v-model="images" :max-count="5" :after-read="afterReadID1" @delete="deleteImg"></van-uploader>
        </template>
      </van-field>
      <van-button type="primary" block @click="submit" class="submit-btn">提交</van-button>
    </van-form>
    </template>
    <template v-if="op=='main'">
        <div class="main">
          <div class="account-info">当前账号：<strong>{{yewuyuanInfo.username}}[{{yewuyuanInfo.No}}]</strong></div>
          <div class="op-box">
            <div class="op-title">操作：</div>
            <van-cell-group>
              <van-cell title="店铺录入" clickable is-link @click="op='add'" />
            </van-cell-group>
          </div>
        </div>
    </template>
    <div v-for="(item,index) in msg" style="font-size: 12px">{{item}}</div>
  </template>
  <template v-else>
    <div class="form">
      <div style="font-size: .32rem;font-weight: bold;text-align: left;line-height: .6rem;padding-top: 1rem;">请使用业务员工号登录：</div>
      <input v-model="loginForm.No" placeholder="工号">
      <input v-model="loginForm.password" type="password" placeholder="密码">
      <div class="login-btn" @click="handleLogin">登录</div>
    </div>
  </template>
  <van-popup v-model="showMap" position="bottom">
    <div class="map-box" :style="{height:windowHeight}">
      <iframe width="100%" height="100%" frameborder=0
              :src="mapUrl">
      </iframe>
    </div>
  </van-popup>
</div>
</template>

<script>
  import { areaList } from '@vant/area-data';
  import * as imageConversion from "image-conversion";
  import wx from "weixin-js-sdk"
    export default {
        name: "yewuyaun",
      data(){
          return {
            op:'main',
            loginForm:{},
            areaList:areaList,
            msg:[],
            showArea:false,
            showMap:false,
            windowHeight:0,
            images:[],
            yewuyuanInfo:{},
            form:{city:[],images:[],lat:0,lnt:''},
            productList:['流量卡','设备']
          }
      },
      created() {
        let localData =  localStorage.getItem("yewuyuanInfo")
        if(localData){
          this.yewuyuanInfo = JSON.parse(localData)
        }
        this.initWechatJs()
        window.addEventListener('message', (event) =>{
          var loc = event.data;
          if(loc && loc.module == 'locationPicker'){
            if(loc.poiaddress){
              this.form.address=loc.poiaddress
            }
            if(loc.latlng) {
              if (loc.latlng.lat) {
                this.form.lat = loc.latlng.lat
              }
              if (loc.latlng.lng) {
                this.form.lng = loc.latlng.lng
              }
            }
            this.showMap = false
          }
          this.$forceUpdate()
        }, false);

      },
      computed:{
        showCity(){
          if(this.form.city){
            return this.form.city.join('/')
          }
          return ''
        },
        mapUrl(){
          if(this.form.lat && this.form.lng) {
            return 'https://apis.map.qq.com/tools/locpicker?search=1&policy=1&type=1&key=GHRBZ-BS3CI-VDSGJ-57XF3-2633K-G7FB7&referer=webserver&coord=' + this.form.lat + ',' + this.form.lng;
          }else{
            return 'https://apis.map.qq.com/tools/locpicker?search=1&policy=1&type=1&key=GHRBZ-BS3CI-VDSGJ-57XF3-2633K-G7FB7&referer=webserver';
          }
        }
      },
      methods:{
        initWechatJs(){
          let url = encodeURIComponent(location.href.split('#')[0])
          this.fetchData('/base/jssdk',{url:url},(res)=>{
            if(res.code){
              wx.config(res.data);
              wx.ready(()=>{
                this.getLocation()
              })
            }
          })
        },
        getLocation(){
          wx.getLocation({
            type: 'gcj02',
            success: (locationInfo) =>{
              this.form.lat = locationInfo.latitude;
              this.form.lng = locationInfo.longitude;
             this.addScript()

            },
            cancel:()=>{
              this.$dialog.alert({
                title: '提示',
                message: '请允许获取位置',
              }).then(() => {
                this.getLocation()
              });
            }
          });
        },
        addScript(){
          var script = document.createElement('script')
          script.charset='utf-8'
          script.src = "https://map.qq.com/api/gljs?v=1.exp&key=GHRBZ-BS3CI-VDSGJ-57XF3-2633K-G7FB7&libraries=service";
          document.querySelector('body').appendChild(script)
          script.onload = ()=>{
            this.getPosition()
          }
        },
          getPosition(){
            var center= new TMap.LatLng(this.form.lat,this.form.lng)
            var server =new TMap.service.Geocoder()
            server.getAddress({location:center}).then(res=>{
              if(res.status === 0){
                this.form.address = res.result.address
                this.form.city[0] = res.result.address_component.province
                this.form.city[1] = res.result.address_component.city
                this.form.city[2] = res.result.address_component.district
              }
            })
          },
        handleLogin(){
          this.fetchData("/yewuyuanfront/login",this.loginForm,res=>{
              if(res.code){
                this.yewuyuanInfo = res.data
                localStorage.setItem("yewuyuanInfo",JSON.stringify(res.data))
              }else{
                this.$toast(res.msg)
              }
          })
        },
        submit(){
          this.form.yewuyuanID = this.yewuyuanInfo.id
          this.fetchData("/yewuyuanfront/addshop",this.form,res=>{
              if(res.code){
                this.$toast.success(res.msg)
                if(res.data.payUrl) {
                  window.location.href = res.data.payUrl
                }else{
                  this.form = {}
                  this.op="main"
                }
              }else{
                this.$toast(res.msg)
              }
          })
        },
        deleteImg(file,detail){
          this.form.images.splice(detail.index,1)
        },
        afterReadID1(file){
          file.status = 'uploading';
          imageConversion.compressAccurately(file.file, 1536).then(blob => {
            let uploadfile = new window.File([blob], file.file.name, file)
            this.uploadFile("/base/uploadImage",uploadfile).then(res=>{
              if(res.code){
                file.status = 'done';
                this.form.images.push(res.data)
              }else{
                file.status = 'failed';
                this.$toast(res.msg)
              }
            }).catch(err=>{console.log(err)})
          });
        },
        onConfirm(values) {
          this.form.city = values
            .filter((item) => !!item)
            .map((item) => item.name)

          this.showArea = false;
        },
        toggle(index) {
          this.$refs.checkboxes[index].toggle();
        },
        onSubmit(){}
      },
      mounted() {
          this.windowHeight = window.innerHeight*0.8+'px'
        /*this.intval = setInterval(()=>{
          document.getElementById("geolocation").contentWindow.postMessage('getLocation', '*');
        },5000)*/

      }
    }
</script>

<style scoped lang="scss">
  .main{
    width: 7rem;
    margin: 1rem auto;
    .account-info{
      font-size: .3rem;
      text-align: left;
    }
    .op-box{
      margin-top: .4rem;
      .op-title{
        font-size: .3rem;
      }
    }
  }
  .form{
    width: 6.9rem;
    margin: 0 auto;
    input{
      width: 100%;
      border: none;
      height: .8rem;
      background: #fbfdff;
      border-radius: .3rem;
      line-height: .8rem;
      font-size: .28rem;
      text-indent: .3rem;
      color: #666;
    }
    .login-btn{
      width: 100%;
      height: .8rem;
      margin-top: 1.6rem;
      line-height: .8rem;
      text-align: center;
      color: #ffff;
      font-size: .3rem;
      background: #0051fe;
      border-radius: .3rem;
    }
  }
  .submit-btn{
    width: 6.6rem;
    margin: .24rem auto;
  }
.form-box{
  width: 7rem;
  margin: .4rem auto;
  border: 1px double #999988;
  border-radius: .24rem;
}
  .map-box{
    width: 7rem;
    height: 100%;
  }
.showAsBlock{
  display: block!important;
}
</style>



// WEBPACK FOOTER //
// src/pages/yewuyuan.vue